module.exports = __webpack_public_path__ + "img/Picture2.d082ee50.jpg";